import i18next from 'i18next';
import { toast } from 'react-toastify';

const sessionIdleWarningId = 'dec-admin-session-idle-warning';

export const showSessionIdleWarning = () => {
  toast.warn(i18next.t('common.messages.warningInactiveSession'), {
    autoClose: false,
    toastId: sessionIdleWarningId
  });
  return sessionIdleWarningId;
};

export const dismissSessionIdleWarning = (id = sessionIdleWarningId) => toast.dismiss(id);

export const notificationSuccess = (message: string) =>
  toast.success(message, {
    toastId: message,
    autoClose: 5000,
    hideProgressBar: true
  });
